import { getCookie, setCookie } from 'tiny-cookie';
import { camelCase, reject, pickBy, isEmpty } from 'lodash';

const cookieName = 'PSTCART';
const cookieBase = {
	cart: {}
};

const cartSections = {
	documents: 'documents'
};

export function initCartCookie() {
	if (getCookie(cookieName)) return;
	const date = new Date();
	date.setDate(date.getDate() + 365);
	setCookie(cookieName, JSON.stringify(cookieBase), { expires: date });
}

export function resetCookie() {
	const date = new Date();
	date.setDate(date.getDate() + 365);
	setCookie(cookieName, JSON.stringify(cookieBase), { expires: date });
}

export function getCartAsJson() {
	const c = getCookie(cookieName);
	if (!c) {
		return {};
	};
	const cart = JSON.parse(c);
	return cart.cart;
}

export function setNewCookie(data) {
	const cookie = { cart: {} };
	cookie.cart = data;
	const date = new Date();
	date.setDate(date.getDate() + 365);
	setCookie(cookieName, JSON.stringify(cookie), { expires: date });
}

export function findItemInCookie(productId, sectionId) {
	let exists = false;
	const cart = getCartAsJson();
	// Pattern used to find item in cookie
	const pattern = { id: productId, section: { id: sectionId } };

	Object.keys(cart).forEach((key) => {
		// Check if item exists
		if (!isEmpty(pickBy(cart[key], pattern))) {
			exists = true;
		}
	});

	return exists;
}

export function addCartItemToCookie(item, documentSection) {
	const cart = getCartAsJson();
	// If this should be set as a document, use document as identifier
	const sectionIdentifier = documentSection ? cartSections.documents : camelCase(item.section.name);
	// Pattern used to find item in cookie
	const pattern = { id: item.id, section: { id: item.section.id } };

	if (cart[sectionIdentifier]) {
		// Only add item if it does not exist
		if (isEmpty(pickBy(cart[sectionIdentifier], pattern))) {
			cart[sectionIdentifier].push(item);
			setNewCookie(cart);
		}
	} else {
		// If sections doesnt exist, create it and add item
		cart[sectionIdentifier] = [];
		cart[sectionIdentifier].push(item);
		setNewCookie(cart);
	}
}

export function removeCartItemFromCookie(productId, sectionId) {
	let r = false; // Value updated if an item is removed
	const cart = getCartAsJson();
	const data = {};
	Object.keys(cart).forEach((key) => {
		// Check if item exists
		r = r ? true : !isEmpty(pickBy(cart[key], { id: productId, section: { id: sectionId } }));
		// Dont pick out item that should be removed
		const sectionItems = reject(cart[key], { id: productId, section: { id: sectionId } });
		// Create section again based on remaining items
		if (sectionItems.length > 0) {
			data[key] = sectionItems;
		}
	});
	setNewCookie(data);
	return r;
}

export function getNumberOfCartItems() {
	const cart = getCartAsJson();
	let count = 0;
	Object.keys(cart).forEach((key) => {
		count += Object.keys(cart[key]).length; // Update count variable for each item
	});
	return count;
}
